function templates(state) {
  return state.templates;
}

const ReportTemplateGetters = {
  templates,
};

export default ReportTemplateGetters;
